module.exports = __webpack_public_path__ + "fonts/414aac2b-b155-4948-8733-ca83f707714f.5617228c.eot";